<template>
   <div class="row" style="height:75%">   
      <div class="col-12 minimenu border-left mt-3" v-if="post">
         <ul class="navbar-nav ">
            <li class="nav-item" v-for="(item) in post" :key="`${item.id}`"> 
            
               <router-link :to="{path:`${link + '/' + item.slug}`, params: {id:item.id, area:$props.area, title:item.titolo}}" v-if="getLink(item) !== 'articolo-specializzazione'">
                    <slot name="header">{{item.titolo}}</slot>
               </router-link>

               <router-link :to="{ name: `${getLink(item)}`, params: {id:item.id, area:$props.area, title:item.titolo, _slug:item.slug}}" v-if="getLink(item) == 'articolo-specializzazione'">
                  <slot name="header">{{item.titolo}}</slot>
               </router-link>
            </li>   
         </ul>   
      </div>
   </div>
</template>

<script>
import { getAssociatedPostsIDs } from './../service';

export default {
   name: "miniMenu",
   props: {
      minimenu: {
         type: Array,
         description: "menuItems in object"
      },
      area: {
        type: String,
        description: "News item object"
      },         
      slug: {
        type: String,
        description: "News item object"
      },         
      _slug: {
        type: String,
        description: "News item object"
      },     
      __slug: {
        type: String,
        description: "News item object"
      },             
   },

   data() {
      return {
         post: null,         
      }
   },

   methods: {
      loadPost: async function(ids) {
         this.data = undefined;
         try {                     
            const result = await getAssociatedPostsIDs(ids);
            this.post = result.posts;
         } catch (ex) {
            console.log('failed loadPost');
            this.post = null;
         }
      },
      getLink(item){         
         if(item.areeSpecializzazione !== null && item.areeSpecializzazione.length > 0){
            return item.schema + '-specializzazione';
         }
         else if(item.s3 !== null && item.s3.length > 0){
            return item.schema + '-s3';
         }
         else{
            return item.schema;
         }
      },      
   },   

   created(){      
      this.loadPost(this.$props.minimenu);
   },

   computed:{
      link(){
         return this.$route.path;
      }  
   }
};
</script>
<style scoped>
   .minimenu.border-left ul{padding-left:6px;}
   @media only screen and (max-width: 776px) {
      .minimenu.border-left{border:0px !important;}
   }
</style>
